<div class="header display-flex">
  <ng-container *ngIf="isLoaded$ | async; else adloopLogo">
    <div class="mr-20">
      <img [src]="image$ | async" style="max-height: 35px;" *ngIf="image$ | async; else adloopLogo">
    </div>
  </ng-container>
  <ng-template #adloopLogo>
    <div class="mr-20">
      <img src='/assets/img/logo_adloop_ondark_2x.png' style="max-height: 35px;">
    </div>
  </ng-template>
</div>
<ng-content></ng-content>
